import React from "react";
import CoursesImage1 from "../Assets/Slide3/Clzvideo.mp4";
import hod from "../Assets/Coursedetails/hod.png";
import chairman from "../Assets/chairmantag.png";
import Cards from "./Cards";

const Welcome = () => {
  return (
    <div>
      <div className="p-4">
        <h1 className="text-black font-Poly text-2xl text-center font-semibold pt-5">
          <span className="text-[#005E8A]">WELCOME </span> TO OUR SRI JYOTHI POLYTECHNIC <span className="text-[#FFA500]">(JPKP)
            </span>
        </h1>
        <hr
          className="section-divider my-1 border-t border-gray-400 mx-auto"     
          style={{ width: "32%" }}
        />

        <video   
          src={CoursesImage1}
          controls
          autoPlay
          muted
          className="w-full rounded-3xl my-6 p-0 sm:p-0 md:p-4 lg:p-4 xl:p-4 2xl:p-4"
        >
          Your browser does not support the video tag.
        </video>
        <div>
          <p className="font-Poly text-lg text-justify leading-[2] w-[95%] mx-auto">
            Welcome to sri jyothi polytechnic (JPKP) We are thrilled to have you
            join our esteemed institution. sri jyothi polytechnic is committed
            to providing high-quality education and nurturing students' talents
            across various technical disciplines. With a focus on practical
            learning, we aim to equip our students with the skills needed for
            success in the real world. Our experienced faculty and modern
            infrastructure ensure that you receive the best possible guidance
            and resources. At sri jyothi polytechnic , we believe in fostering
            creativity, innovation, and holistic development. We encourage you
            to actively participate in various extracurricular activities to
            enrich your learning experience. Your journey with us will be one of
            growth, challenge and achievement. Together, we will work towards
            building a bright future for you.We are confident that your time at
            sri jyothi polytechnic will be both rewarding and transformative.
            Take full advantage of the opportunities that come your way, whether
            in academics, projects, or campus events. Remember, your efforts
            today will shape the path for a prosperous tomorrow. Welcome aboard!
            we look forward to your success!
          </p>
        </div>
        <div className="flex flex-col md:flex-row items-start mt-4 space-y-6 md:space-y-0">
          {/* Right Section */}
          <div className="w-full md:w-1/4 flex justify-center items-center">
            <div className="relative ">
              <img
                src={chairman}
                alt="HOD"
                className="w-full h-auto shadow"
                style={{ maxWidth: "300px" }}
              />
              <div>
                {/* <p className="text-[10px] mt-5 ">
                  (More Than 4 Decades EXPRETISATION in Polytechnic Education,
                  Teaching & Training)
                </p> */}
              </div>
              {/* <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center">
              <h6 className="text-lg text-gray-500 font-Poly">Chairman</h6>
              <p className="font-semibold text-lg font-Poly">Sri S V Ramana</p>
            </div> */}
            </div>
          </div>
          {/* Left Section */}
          <div className="w-full md:w-3/4 px-6 mt-15">
            <p className="font-Poly text-lg text-justify leading-[2]">
              "As Chairman of our esteemed institution, it has been my honor to
              be a part of this great institute. In my time here, I have
              witnessed the hard work, dedication, and passion our students put
              into reaching the highest level of their academic life. Our
              efforts do not go unnoticed—many of our meritorious students are
              receiving well-deserved recognition for their achievements. As an
              institution, we continually strive to play a major role in the
              development of rural education, bringing out the best students
              through extensive training methodologies used by our expert
              trainers, all aimed at providing quality education. Through events
              like 'Motivate', we define ourselves as aspirational role models
              for every student, both in academics and career development
              outside of academics."
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Welcome;
